// 郵便番号と都道府県を紐付けるための設定ファイル。
// PREFIX:郵便番号の前方一致 ハイフン無し
//ID:都道府県ID
// 順番に前方一致で一致したら、その都道府県IDを返す。
// ロジックは以下を参照
// https://nixeneko.hatenablog.com/entry/2020/12/29/001936
window.CustomDeliveryDatetime.settings.POSTCODE_PREFS = [
        // 例外
        { PREFIX: "018550",ID: 2 },
        { PREFIX: "311441",ID: 9 },
        { PREFIX: "349122",ID: 9 },
        { PREFIX: "3701507",ID: 11 },
        { PREFIX: "3840097",ID: 10 },
        { PREFIX: "389012",ID: 10 },
        { PREFIX: "389226",ID: 15 },
        { PREFIX: "431412",ID: 23 },
        // { PREFIX: "4980000",ID: null },
        { PREFIX: "49808",ID: 24 },
        { PREFIX: "520046",ID: 26 },
        { PREFIX: "56308",ID: 28 },
        // { PREFIX: "6180000",ID: null },
        { PREFIX: "6180001",ID: 27 },
        { PREFIX: "6180002",ID: 27 },
        { PREFIX: "6180003",ID: 27 },
        { PREFIX: "6180004",ID: 27 },
        { PREFIX: "618001",ID: 27 },
        { PREFIX: "618002",ID: 27 },
        { PREFIX: "630027",ID: 27 },
        { PREFIX: "647127",ID: 29 },
        { PREFIX: "64713",ID: 24 },
        { PREFIX: "64715",ID: 29 },
        { PREFIX: "64803",ID: 29 },
        { PREFIX: "68401",ID: 32 },
        { PREFIX: "68402",ID: 32 },
        { PREFIX: "68403",ID: 32 },
        { PREFIX: "68404",ID: 32 },
        { PREFIX: "685",ID: 32 },
        { PREFIX: "8115",ID: 42 },
        { PREFIX: "817",ID: 42 },
        { PREFIX: "839142",ID: 44 },
        { PREFIX: "84804",ID: 42 },
        // { PREFIX: "8710000",ID: null },
        { PREFIX: "871022",ID: 40 },
        { PREFIX: "87108",ID: 40 },
        { PREFIX: "87109",ID: 40 },
        { PREFIX: "9220679",ID: 18 },
        { PREFIX: "939017",ID: 17 },
        { PREFIX: "949832",ID: 20 },
        
        // 通常のルール
        { PREFIX: "00",ID: 1 }, // 北海道
        { PREFIX: "01",ID: 5 }, // 秋田県
        { PREFIX: "02",ID: 3 }, // 岩手県
        { PREFIX: "03",ID: 2 }, // 青森県
        { PREFIX: "04",ID: 1 }, // 北海道
        { PREFIX: "05",ID: 1 }, // 北海道
        { PREFIX: "06",ID: 1 }, // 北海道
        { PREFIX: "07",ID: 1 }, // 北海道
        { PREFIX: "08",ID: 1 }, // 北海道
        { PREFIX: "09",ID: 1 }, // 北海道
        { PREFIX: "10",ID: 13 }, // 東京都
        { PREFIX: "11",ID: 13 }, // 東京都
        { PREFIX: "12",ID: 13 }, // 東京都
        { PREFIX: "13",ID: 13 }, // 東京都
        { PREFIX: "14",ID: 13 }, // 東京都
        { PREFIX: "15",ID: 13 }, // 東京都
        { PREFIX: "16",ID: 13 }, // 東京都
        { PREFIX: "17",ID: 13 }, // 東京都
        { PREFIX: "18",ID: 13 }, // 東京都
        { PREFIX: "19",ID: 13 }, // 東京都
        { PREFIX: "20",ID: 13 }, // 東京都
        { PREFIX: "21",ID: 14 }, // 神奈川県
        { PREFIX: "22",ID: 14 }, // 神奈川県
        { PREFIX: "23",ID: 14 }, // 神奈川県
        { PREFIX: "24",ID: 14 }, // 神奈川県
        { PREFIX: "25",ID: 14 }, // 神奈川県
        { PREFIX: "26",ID: 12 }, // 千葉県
        { PREFIX: "27",ID: 12 }, // 千葉県
        { PREFIX: "28",ID: 12 }, // 千葉県
        { PREFIX: "29",ID: 12 }, // 千葉県
        { PREFIX: "30",ID: 8 }, // 茨城県
        { PREFIX: "31",ID: 8 }, // 茨城県
        { PREFIX: "32",ID: 9 }, // 栃木県
        { PREFIX: "33",ID: 11 }, // 埼玉県
        { PREFIX: "34",ID: 11 }, // 埼玉県
        { PREFIX: "35",ID: 11 }, // 埼玉県
        { PREFIX: "36",ID: 11 }, // 埼玉県
        { PREFIX: "37",ID: 10 }, // 群馬県
        { PREFIX: "38",ID: 20 }, // 長野県
        { PREFIX: "39",ID: 20 }, // 長野県
        { PREFIX: "40",ID: 19 }, // 山梨県
        { PREFIX: "41",ID: 22 }, // 静岡県
        { PREFIX: "42",ID: 22 }, // 静岡県
        { PREFIX: "43",ID: 22 }, // 静岡県
        { PREFIX: "44",ID: 23 }, // 愛知県
        { PREFIX: "45",ID: 23 }, // 愛知県
        { PREFIX: "46",ID: 23 }, // 愛知県
        { PREFIX: "47",ID: 23 }, // 愛知県
        { PREFIX: "48",ID: 23 }, // 愛知県
        { PREFIX: "49",ID: 23 }, // 愛知県
        { PREFIX: "50",ID: 21 }, // 岐阜県
        { PREFIX: "51",ID: 24 }, // 三重県
        { PREFIX: "52",ID: 25 }, // 滋賀県
        { PREFIX: "53",ID: 27 }, // 大阪府
        { PREFIX: "54",ID: 27 }, // 大阪府
        { PREFIX: "55",ID: 27 }, // 大阪府
        { PREFIX: "56",ID: 27 }, // 大阪府
        { PREFIX: "57",ID: 27 }, // 大阪府
        { PREFIX: "58",ID: 27 }, // 大阪府
        { PREFIX: "59",ID: 27 }, // 大阪府
        { PREFIX: "60",ID: 26 }, // 京都府
        { PREFIX: "61",ID: 26 }, // 京都府
        { PREFIX: "62",ID: 26 }, // 京都府
        { PREFIX: "63",ID: 29 }, // 奈良県
        { PREFIX: "64",ID: 30 }, // 和歌山県
        { PREFIX: "65",ID: 28 }, // 兵庫県
        { PREFIX: "66",ID: 28 }, // 兵庫県
        { PREFIX: "67",ID: 28 }, // 兵庫県
        { PREFIX: "68",ID: 31 }, // 鳥取県
        { PREFIX: "69",ID: 32 }, // 島根県
        { PREFIX: "70",ID: 33 },//岡山県
        { PREFIX: "71",ID: 33 },//岡山県
        { PREFIX: "72",ID: 34 },//広島県
        { PREFIX: "73",ID: 34 },//広島県
        { PREFIX: "74",ID: 35 },//山口県
        { PREFIX: "75",ID: 35 },//山口県
        { PREFIX: "76",ID: 37 },//香川県
        { PREFIX: "77",ID: 36 },//徳島県
        { PREFIX: "78",ID: 39 },//高知県
        { PREFIX: "79",ID: 38 },//愛媛県
        { PREFIX: "80",ID: 40 },//福岡県
        { PREFIX: "81",ID: 40 },//福岡県
        { PREFIX: "82",ID: 40 },//福岡県
        { PREFIX: "83",ID: 40 },//福岡県
        { PREFIX: "84",ID: 41 },//佐賀県
        { PREFIX: "85",ID: 42 },//長崎県
        { PREFIX: "86",ID: 43 },//熊本県
        { PREFIX: "87",ID: 44 },//大分県
        { PREFIX: "88",ID: 45 },//宮崎県
        { PREFIX: "89",ID: 46 },//鹿児島県
        { PREFIX: "90",ID: 47 },//沖縄県
        { PREFIX: "91",ID: 18 },//福井県
        { PREFIX: "92",ID: 17 },//石川県
        { PREFIX: "93",ID: 16 },//富山県
        { PREFIX: "94",ID: 15 },//新潟県
        { PREFIX: "95",ID: 15 },//新潟県
        { PREFIX: "96",ID: 7 },//福島県
        { PREFIX: "97",ID: 7 },//福島県
        { PREFIX: "98",ID: 4 },//宮城県
        { PREFIX: "99",ID: 6 },//山形県
    ];